import React, { useState } from 'react';

import List from '../../atoms/List';
import { useDialog } from '../../atoms/Dialog';
import FormOdpoved from './FormOdpovedForb';
import { Forb, ForbQuestion, forbDelete, forbList, forbQuestionDelete, forbQuestionList } from '../../../api';
import FormOtazka from './FormOtazkaForb';
import useApi from '../../../hooks/useApi';
import LoadingContainer from '../../hoc/LodingContainer';


function ForbQA() {
    const { data: answers, call: reloadA, loading: loadingA, error: errorA, called: calledA } =
        useApi<Forb[], void>(forbList({ autoFetch: true }));
    const { data: questions, call: reloadQ, loading: loadingQ, error: errorQ, called: calledQ } =
        useApi<ForbQuestion[], void>(forbQuestionList({ autoFetch: true }));

    const [selectedAnswer, setSelectedAnswer] = useState<Forb['id'] | undefined>(undefined);

    const { call: delAnswer, sending: sendingDelA, error: errorDelA, called: calledDelA } =
        useApi<void, number>({});
    const { call: delQuestion, sending: sendingDelQ, error: errorDelQ, called: calledDelQ } =
        useApi<void, number>({});

    const { openDialog } = useDialog();

    const deleteAnswer =
        async (id: any) => {
            // eslint-disable-next-line no-restricted-globals
            if (!confirm(`Opravdu smazat odpověď s ID ${id}?\nSmazány budou také navazující otázky.`)) return;
            if (await delAnswer(forbDelete(id)) === false) return;
            setSelectedAnswer(undefined);
            reloadA();
            reloadQ();
        }

    const deleteQuestion =
        async (id: any) => {
            // eslint-disable-next-line no-restricted-globals
            if (!confirm(`Opravdu smazat otázku s ID ${id}?`)) return;
            if (await delQuestion(forbQuestionDelete(id)) === false) return;
            reloadQ();
        }

    return (
        <>
            <h1>Zakázaná témata</h1>

            <LoadingContainer loading={loadingA || loadingQ || sendingDelA || sendingDelQ}
                error={errorA || errorQ || errorDelA || errorDelQ}
                called={calledA || calledQ || calledDelA || calledDelQ} >

                {answers &&
                    <div className='display-flex mt-20'>
                        <div className='w-100'>
                            <div className='pr-5'>
                                <List
                                    title='Odpovědi'
                                    className='list-scroll'
                                    columns={[
                                        { key: 'id', label: 'ID' },
                                        { key: 'answer', label: 'Odpověď' },
                                    ]}
                                    rows={answers}
                                    selectable='single'
                                    selected={selectedAnswer === undefined ? undefined : [selectedAnswer]}
                                    onChangeSelect={(ids) => setSelectedAnswer(ids.length ? ids[0] : undefined)}
                                    onNew={() => openDialog({
                                        title: 'Nová odpověď',
                                        content: (
                                            <FormOdpoved
                                                reload={reloadA}
                                            />
                                        ),
                                        onSuccess: () => document.getElementById('form-answer-submit')?.click()
                                    })}
                                    onEdit={(id) => openDialog({
                                        title: 'Upravit odpověď',
                                        content: (
                                            <FormOdpoved
                                                reload={reloadA}
                                                data={answers.find(item => item.id === id)} />
                                        ),
                                        onSuccess: () => document.getElementById('form-answer-submit')?.click()
                                    })}
                                    onDelete={(id) => deleteAnswer(id)}
                                />
                            </div>
                        </div>

                        {
                            questions && selectedAnswer !== undefined &&
                            <div className='w-100'>
                                <div className='pl-5'>
                                    <List
                                        title={`Otázky k odpovědi s ID ${selectedAnswer}`}
                                        className='list-scroll'
                                        columns={[
                                            { key: 'id', label: 'ID' },
                                            { key: 'question', label: 'Otázka' },
                                        ]}
                                        rows={questions.filter(({ parent_answer_id }) => selectedAnswer === undefined || parent_answer_id === selectedAnswer)}
                                        onNew={() => openDialog({
                                            title: 'Nová otázka',
                                            content: (
                                                <FormOtazka
                                                    reload={reloadQ}
                                                    odpoved={selectedAnswer} />
                                            ),
                                            onSuccess: () => document.getElementById('form-question-submit')?.click()
                                        })}
                                        onEdit={(id) => openDialog({
                                            title: 'Upravit otázku',
                                            content: (
                                                <FormOtazka
                                                    reload={reloadQ}
                                                    odpoved={selectedAnswer}
                                                    data={questions.find(item => item.id === id)} />
                                            ),
                                            onSuccess: () => document.getElementById('form-question-submit')?.click()
                                        })}
                                        onDelete={(id) => deleteQuestion(id)}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                }
            </LoadingContainer>
        </>
    );
}

export default ForbQA;
